import RegisterPage from './RegisterPage.jsx'
export default () => {
    return {
        path: '/register',
        element: <RegisterPage />,
    }
}
